<template>
    <div class="container">
        <div class="body-modal modal-reference" ref="modalReference">
            <div>
                <div class="content">
                    <div>
                        <div>
                            <span class="title mobile">
                                <span>{{ reference.title }}</span>
                                <span @click="share" class="btn-share"><FontAwesomeIcon icon="share-nodes" /></span>
                            </span>
                        </div>

                        <div v-if="'diaporama' in reference && 'video' in reference" class="diaporama">
                            <Splide :options="{ type: 'fade', rewind: true, drag: true, autoplay: false, interval: 4000 }" class="slide-ref" ref="splideRef">
                                <SplideSlide>
                                    <div>
                                        <video controls playsinline ref="video-ref" v-if="displayVideo">
                                            <source :src="'./refs/' + reference.video" type="video/mp4" />
                                        </video>
                                    </div>
                                </SplideSlide>
                                <SplideSlide v-for="(img, index) in reference.diaporama" :key="index">
                                    <div>
                                        <img :src="'./refs/' + img" alt="" />
                                    </div>
                                </SplideSlide>
                            </Splide>
                        </div>

                        <div v-if="'diaporama' in reference && !('video' in reference)" class="diaporama">
                            <Splide :options="{ type: 'fade', rewind: true, drag: true, autoplay: false, interval: 4000 }" class="slide-ref">
                                <SplideSlide v-for="(img, index) in reference.diaporama" :key="index">
                                    <div>
                                        <img :src="'./refs/' + img" alt="" />
                                    </div>
                                </SplideSlide>
                            </Splide>
                        </div>

                        <div v-if="'video' in reference && !('diaporama' in reference)">
                            <video controls playsinline ref="video-ref" v-if="displayVideo">
                                <source :src="'./refs/' + reference.video" type="video/mp4" />
                            </video>
                        </div>

                        <div v-if="'game' in reference">
                            <iframe class="iframe-game" :src="'./jeux/' + reference.game" />
                        </div>

                        <div v-if="'youtube' in reference" class="video-responsive-ref">
                            <YouTube :src="reference.youtube" @ready="onReady" ref="youtubePlayer" />
                        </div>
                    </div>
                    <div>
                        <div>
                            <span class="title desktop">
                                <span>{{ reference.title }}</span>
                                <span @click="share" class="btn-share"><FontAwesomeIcon icon="share-nodes" /></span>
                            </span>
                            <div v-html="reference.content" class="desc"></div>
                        </div>
                        <div>
                            <div class="tags">
                                <span v-for="(t, idx) in reference.tags" :key="idx" @click="runFilter(t)" class="btnfill">{{ t }}</span>
                            </div>
                            <div class="comment" v-if="reference.comment">
                                <span v-if="reference.comment.content">«&nbsp;<span v-html="reference.comment.content"></span>&nbsp;»</span>
                                <span v-if="reference.comment.author">{{ reference.comment.author }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="other-refs" v-if="withCommonTags.length > 0">
                <p>{{ $t("message.other_refs") }}</p>

                <div>
                    <div v-for="(r, idx) in withCommonTags" :key="idx" @click="showNewReference(r.id)">
                        <div>
                            <img :src="'./refs/' + r.promote" alt="" />
                        </div>
                        <div>
                            <span>{{ r.title }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal de partage -->
        <div v-if="showShareModal" class="modal-overlay">
            <div class="modal-content">
                <h3>{{ $t("message.share_this_reference") }}</h3>
                <input type="text" :value="currentUrl" readonly @click="$event.target.select()" />
                <p v-if="copySuccess" class="copy-success">{{ $t("message.link_copied") }}</p>
                <button class="btn-copy" @click="copyUrl">{{ $t("message.copy_link") }}</button>
                <button class="btn-close" @click="showShareModal = false">{{ $t("message.share_close") }}</button>
            </div>
        </div>
    </div>
</template>

<script>
import IconHaikara from "../components/img/IconHaikara.vue";

import { library } from "@fortawesome/fontawesome-svg-core";
import { faShareNodes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(faShareNodes);

import YouTube from "vue3-youtube";

import { Splide, SplideSlide } from "@splidejs/vue-splide";
import "@splidejs/vue-splide/css";

export default {
    name: "Reference",
    data() {
        return {
            local: "fr",
            withCommonTags: [],
            withoutCommonTags: [],
            reference: null,
            displayVideo: true,
            indexRef: null,

            showShareModal: false,
            currentUrl: "",
            copySuccess: false,
        };
    },
    components: {
        FontAwesomeIcon,
        IconHaikara,
        Splide,
        SplideSlide,
        YouTube,
    },
    watch: {
        "$i18n.locale": function (locale) {
            this.local = locale;
        },
    },
    beforeMount() {
        this.reference = this.$store.state.app.modal.content;
        this.indexRef = this.$store.state.app.modal.index;
        this.runPropositions();
    },
    mounted() {
        this.local = this.$i18n.locale;
        if (this.reference.video) {
            this.displayVideo = true;
            let video = this.$refs["video-ref"];
            video.play();
        }

        this.$nextTick(() => {
            const splide = this.$refs.splideRef?.splide;
            if (splide) {
                splide.on("moved", this.onSlideMove);
            }
        });
    },
    updated() {
        if (this.reference.video && this.$store.state.app.modal.display && this.displayVideo) {
            let video = this.$refs["video-ref"];
            video.play();
        }
    },
    methods: {
        share() {
            const url = window.location.origin + window.location.pathname + "?ref=" + this.indexRef;
            this.currentUrl = url;
            this.copySuccess = false;
            this.showShareModal = true;
        },
        copyUrl() {
            navigator.clipboard.writeText(this.currentUrl).then(() => {
                this.copySuccess = true;
                setTimeout(() => {
                    this.copySuccess = false;
                }, 2500);
            });
        },
        onSlideMove() {
            if (this.reference.video) {
                this.displayVideo = true;
                let video = this.$refs["video-ref"];
                video.pause();
            }
        },
        onReady() {
            this.$refs.youtubePlayer.playVideo();
        },
        showListReferences() {
            let video = this.$refs["video-ref"];
            if (video) video.pause();

            setTimeout(() => {
                this.$store.dispatch("app/displayModal", {
                    display: false,
                });
            }, 500);
        },
        showNewReference(idx) {
            this.indexRef = idx;
            (this.reference = this.$store.getters["app/getRef"](this.local, idx)), this.runPropositions();
            this.displayVideo = false;
            setTimeout(() => {
                this.displayVideo = true;
            }, 200);
        },
        runFilter(tag) {
            this.$store.dispatch("app/setFilter", "");

            for (let i = 0; i < this.$store.state.app.filters[this.local].length; i++) {
                let filterMetier = this.$store.state.app.filters[this.local][i];
                if (tag === filterMetier) this.$store.dispatch("app/setFilter", tag);
            }

            const el = document.getElementById("content");
            if (el) {
                const y = el.getBoundingClientRect().top + window.scrollY;
                window.scrollTo({ top: y, behavior: "smooth" });
            }

            this.$store.dispatch("app/displayModal", {
                display: false,
            });
        },
        runPropositions() {
            console.log('this.reference >>>> ', this.reference)
            
            const references = this.$store.getters["app/getRefs"](this.local);
            const tags = this.reference.tags;
            const currentTitle = this.reference.title;

            this.withCommonTags = [];
            this.withoutCommonTags = [];

            if (!references || references.length === 0) return;

            const alreadyAdded = new Set();

            references.forEach((ref, idx) => {
                if (ref.title === currentTitle) return;

                const hasCommonTag = ref.tags.some((tag) => tags.includes(tag));

                ref.idx = idx;

                if (hasCommonTag && !alreadyAdded.has(ref.title)) {
                    this.withCommonTags.push(ref);
                    alreadyAdded.add(ref.title);
                } else if (!hasCommonTag && !alreadyAdded.has(ref.title)) {
                    this.withoutCommonTags.push(ref);
                    alreadyAdded.add(ref.title);
                }
            });

            this.shuffleArray(this.withCommonTags);
            this.shuffleArray(this.withoutCommonTags);

            this.withCommonTags = this.withCommonTags.slice(0, 3);

            if (this.withCommonTags.length < 3) {
                const remaining = 3 - this.withCommonTags.length;
                this.withCommonTags.push(...this.withoutCommonTags.slice(0, remaining));
            }
        },
        shuffleArray(inputArray) {
            inputArray.sort(() => Math.random() - 0.5);
        },
    },
};
</script>

<style lang="scss">
.slide-ref .splide__pagination {
    position: static;
    margin-top: 1rem;
}

.slide-ref .splide__arrow {
    top: calc(50% - 1rem);
}

.slide-ref .splide__list {
    backface-visibility: hidden !important;
    display: flex !important;
    height: 100% !important;
    margin: 0 !important;
    padding: 0 !important;
}
.slide-ref .splide img {
    width: 100% !important;
}

.video-responsive-ref {
    > div {
        overflow: hidden;
        padding-bottom: 56.25%;
        position: relative;
        height: 0 !important;
        width: 100% !important;

        iframe {
            left: 0;
            top: 0;
            height: 100% !important;
            width: 100% !important;
            position: absolute !important;
        }
    }
}
</style>

<style lang="scss" scoped>
.splide img {
    width: 100%;
}

.slide-ref .splide__slide {
    width: 100%;
}

.menu-ref {
    margin: 0;
}

.modal-reference {
    padding: 6rem 0;
    box-sizing: border-box;

    > div {
        max-width: 1400px;
        margin: auto;
    }

    .content {
        display: flex;
        flex-flow: row nowrap;

        > div {
            &:first-child {
                width: 60%;
                flex: 0 0 60%;
                padding-right: 2rem;
                box-sizing: border-box;
            }

            &:last-child {
                width: 40%;
                flex: 0 0 40%;
                display: flex;
                flex-flow: column;
                justify-content: space-between;

                > div:last-child {
                    margin-bottom: 2rem;
                    box-sizing: border-box;
                }
            }
        }

        video {
            width: 100%;
            aspect-ratio: 16 / 9;
            background: #000;
        }

        .iframe-game {
            border-radius: 15px;
            overflow: hidden;
            width: 100%;
            aspect-ratio: 1620/911;
            border: 0;
        }
    }

    .title {
        font-family: Oswald, sans-serif;
        color: #fff;
        font-size: 2.2rem;
        padding: 0;
        font-weight: 700;

        span:first-child {
            margin-right: 1rem;
        }

        &.mobile {
            display: none;
        }
    }

    .desc {
        color: #fff;
        padding: 0;
        font-size: 1.2rem;
        font-weight: 300;
        font-family: "Roboto", sans-serif;
    }

    .comment {
        color: #00d5ff;
        padding: 0;
        font-size: 1.2rem;
        font-weight: 300;
        font-style: italic;
        display: flex;
        flex-flow: column;

        > span {
            &:first-child {
                padding: 1rem 0;
            }

            &:last-child {
                text-align: center;
            }
        }
    }

    .btn-share {
        cursor: pointer;
        transition: all 0.3s;
        background-color: #0e3077;
        color: #fff;
        width: 2rem;
        height: 2rem;
        border-radius: 5px;
        font-size: 1rem;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        position: relative;
        top: -6px;

        &:hover {
            color: #00d5ff;
        }
    }

    .tags {
        padding: 1rem 0 0;
        font-size: 1rem;

        span {
            margin-right: 0.6rem;
            cursor: pointer;
            transition: all 0.3s;
            background-color: #0e3077;
            color: #fff;
            display: inline-block;
            padding: 0.5rem;
            border-radius: 5px;
            margin-bottom: 0.5rem;

            &:hover {
                color: #ff0000;
            }
        }
    }
}

.other-refs {
    > p {
        font-family: Oswald, sans-serif;
        color: #fff;
        font-size: 1.4rem;
        margin-top: 4rem;
    }

    > div {
        display: flex;
        flex-flow: row nowrap;
        align-items: stretch;
        width: 100%;

        > div {
            flex: 0 0 33.33333333%;
            overflow: hidden;
            background-color: #fff;
            display: flex;
            flex-flow: row nowrap;
            align-items: center;
            border-radius: 8px;
            color: #000;
            cursor: pointer;
            padding: 1rem;
            box-sizing: border-box;
            transition: all 0.3s;
            font-family: Oswald, sans-serif;

            &:nth-child(2) {
                margin: 0 1rem;
            }

            &:hover,
            &:focus {
                transform: scale(1.05);
                z-index: 1;
            }

            > div {
                &:first-child {
                    flex: 1;

                    img {
                        width: 100%;
                        display: block;
                        border-radius: 8px;
                    }
                }

                &:last-child {
                    flex: 2;
                    padding-left: 1rem;
                    box-sizing: border-box;
                }
            }
        }
    }
}

// Modal de partage
.modal-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10000;
    padding: 1rem;
}

.modal-content {
    background-color: #0e3077;
    color: #fff;
    padding: 2rem;
    border-radius: 10px;
    width: 100%;
    max-width: 450px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
    font-family: Oswald, sans-serif;
    text-align: center;

    h3 {
        margin: 0 1rem 1rem;
        font-size: 1.5rem;
        font-weight: 100;
    }

    input {
        width: 100%;
        padding: 0.75rem;
        box-sizing: border-box;
        font-size: 1rem;
        border: none;
        border-radius: 5px;
        margin-bottom: 1rem;
        font-family: Roboto, sans-serif;
        color: #000;
    }

    .btn-copy,
    .btn-close {
        padding: 0.5rem 1.2rem;
        margin: 0.3rem 0.3rem 0;
        border: none;
        border-radius: 5px;
        background-color: #00d5ff;
        color: #000;
        font-weight: bold;
        font-family: Oswald, sans-serif;
        cursor: pointer;
        transition: background-color 0.3s;
        font-size: 1rem;

        &:hover {
            background-color: #00b5dd;
        }
    }

    .copy-success {
        margin-top: 1rem;
        color: #00ffae;
        font-size: 1rem;
        //font-family: Roboto, sans-serif;
    }
}

@media (max-width: 1400px) {
    .modal-reference {
        .content {
            > div {
                &:first-child {
                    width: 60%;
                    flex: 0 0 60%;
                    padding-right: 2rem;
                }

                &:last-child {
                    width: 40%;
                    flex: 0 0 40%;

                    > div:last-child {
                        margin-bottom: 2rem;
                    }
                }
            }
        }

        .title {
            font-size: 2rem;
        }

        .desc {
            font-size: 1.2rem;
        }

        .comment {
            font-size: 1.2rem;
        }

        .tags {
            padding: 1rem 0 0;

            span {
                margin-right: 0.6rem;
                padding: 0.5rem;
            }
        }
    }

    .other-refs {
        > p {
            font-size: 1.4rem;
            margin-top: 4rem;
        }

        > div {
            > div {
                flex: 0 0 33.33333333%;
                padding: 1rem;

                > div {
                    &:last-child {
                        padding-left: 1rem;
                    }
                }
            }
        }
    }
}
@media (max-width: 1200px) {
    .modal-reference {
        .content {
            > div {
                &:first-child {
                    width: 60%;
                    flex: 0 0 60%;
                    padding-right: 2rem;
                }

                &:last-child {
                    width: 40%;
                    flex: 0 0 40%;

                    > div:last-child {
                        margin-bottom: 2rem;
                    }
                }
            }
        }

        .title {
            font-size: 1.8rem;
        }

        .desc {
            font-size: 1.1rem;
        }

        .comment {
            font-size: 1.1rem;
        }

        .tags {
            padding: 1rem 0 0;

            span {
                margin-right: 0.6rem;
                padding: 0.5rem;
            }
        }
    }

    .other-refs {
        > p {
            font-size: 1.3rem;
            margin-top: 4rem;
        }

        > div {
            > div {
                flex: 0 0 33.33333333%;
                padding: 1rem;

                > div {
                    &:last-child {
                        padding-left: 1rem;
                    }
                }
            }
        }
    }
}

@media (max-width: 992px) {
    .modal-reference {
        .content {
            flex-flow: column;

            > div {
                &:first-child {
                    width: 100%;
                    flex: 0 0 100%;
                    padding-right: 0;
                }

                &:last-child {
                    width: 100%;
                    flex: 0 0 100%;

                    > div:last-child {
                        margin-bottom: 2rem;
                    }
                }
            }
        }

        .title {
            font-size: 1.8rem;

            &.desktop {
                display: none;
            }

            &.mobile {
                display: block;
                margin-bottom: 0.7rem;
            }
        }

        .desc {
            font-size: 1.1rem;
        }

        .comment {
            font-size: 1.1rem;
        }

        .tags {
            padding: 1rem 0 0;

            span {
                margin-right: 0.6rem;
                padding: 0.5rem;
            }
        }
    }

    .other-refs {
        > p {
            font-size: 1.2rem;
            margin-top: 3rem;
        }

        > div {
            flex-flow: column;

            > div {
                flex: 0 0 100%;
                padding: 1rem;
                margin-bottom: 1rem;

                > div {
                    &:last-child {
                        padding-left: 1rem;
                    }
                }

                &:nth-child(2) {
                    margin: 0;
                    margin-bottom: 1rem;
                }

                &:hover,
                &:focus {
                    transform: scale(1.02);
                }
            }
        }
    }
    
    .btn-share {
        top: -4px;
    }
}

@media (max-width: 768px) {
    .modal-reference {
        padding: 4rem 0;
    }
}

@keyframes opacity-in {
    100% {
        opacity: 1;
    }
}
</style>
